import { Injectable } from '@angular/core';
import { EventsBlueprint } from './events-blueprint';
import { Store } from '@ngrx/store';
import { entityActions } from 'src/app/state/entities/entity.actions';
import { EntityType, Components, CollisionType } from 'src/app/state/entities/entity.model';
import { Vector3 } from 'three';
import { EventsWebsocketService } from '../../../services/entities/events-websocket.service';
import { generateUUID } from 'three/src/math/MathUtils.js';

@Injectable({
  providedIn: 'root'
})
export class OnlineTimerService extends EventsBlueprint {
  override prompt = "timer"
  constructor(
    private store: Store,
    private websocketService: EventsWebsocketService,
  ) {
    super()
  }

  override start() {
    const id = generateUUID();
    this.websocketService.dispatch(
      entityActions.netCreated({
        entity: {
          id: id,
          type: EntityType.Timer,
          ownerId: "self",
          components: [],
          coord: new Vector3(-2, 0, Math.random() * 50),
          componentProperties: { },
          collisionType: CollisionType.Obstacle,
          creationDate: new Date(),
        },
      }),
    );
    this.websocketService.dispatch(
      entityActions.netCreated({
        entity: {
          id: generateUUID(),
          type: EntityType.Timer,
          ownerId: "self",
          components: [],
          coord: new Vector3(-2, 0, Math.random() * 50),
          componentProperties: { },
          collisionType: CollisionType.Obstacle,
          creationDate: new Date(),
        },
      }),
    );
  }
}
